module.exports = __webpack_public_path__ + "static/media/BigCats.95dad286.png";